import React from 'react';
import { Coffee, Sun, Moon, Apple } from 'lucide-react';
import { motion } from 'framer-motion';

interface MealTypeSelectorProps {
  selectedType: string;
  onSelect: (type: string) => void;
}

const mealTypes = [
  { id: 'breakfast', label: 'Breakfast', icon: <Coffee className="w-4 h-4" /> },
  { id: 'lunch', label: 'Lunch', icon: <Sun className="w-4 h-4" /> },
  { id: 'dinner', label: 'Dinner', icon: <Moon className="w-4 h-4" /> },
  { id: 'snack', label: 'Snack', icon: <Apple className="w-4 h-4" /> }
];

export function MealTypeSelector({ selectedType, onSelect }: MealTypeSelectorProps) {
  return (
    <div className="theme-card p-4">
      <div className="grid grid-cols-4 gap-2">
        {mealTypes.map((type) => (
          <motion.button
            key={type.id}
            onClick={() => onSelect(type.id)}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            className={`p-3 rounded-lg transition-colors flex flex-col items-center gap-2 relative overflow-hidden group ${
              selectedType === type.id
                ? 'bg-primary text-primary-foreground'
                : 'bg-muted text-muted-foreground hover:bg-muted/70'
            }`}
          >
            <div className="relative">
              {type.icon}
              {selectedType === type.id && (
                <div className="absolute inset-0 bg-current opacity-20 blur-xl rounded-full" />
              )}
            </div>
            <span className="text-sm font-medium">{type.label}</span>
            
            {/* Hover Effect */}
            <div className="absolute inset-0 bg-gradient-to-br from-primary/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
          </motion.button>
        ))}
      </div>
    </div>
  );
}